import { Api } from 'utils';

class CalificationService {

    static admin = {
        get: async (params?: any) => Api.createResponse('admin/califications/get', params),
        delete: async (params?: any) => Api.createResponse('admin/califications/delete', params),
    }


}

export default CalificationService;